<template>
    <b-container>
        <b-row>
            <b-col>
                <app-title text="Diagnostico de riesgos" />
            </b-col>
        </b-row>
            <b-row>
                <b-tabs content-class="mt-3">
                    <b-tab v-for="riskDiagnosis in riskDiagnoses" :key="riskDiagnosis.id" :title="riskDiagnosis.file_name">
                        <h4 class="mt-4">Documento: {{riskDiagnosis.file_name}}.{{riskDiagnosis.ext}}</h4>
                        <b-row>
                            <b-col class="mt-4" v-html="riskDiagnosis.embed_code"> </b-col>
                        </b-row>
                    </b-tab>
                </b-tabs>
            </b-row>
    </b-container>
</template>
<script>
export default {
    data: () => ({
        riskDiagnoses: [],
        isSelected: false,
        embedCode: ''
    }),
    methods: {
        async loadRiskDiagnoses() {
            try {
                const { data } = await repo.get('risk-diagnosis',{
                    clientId: this.client.id
                })
                this.riskDiagnoses = data;
            } catch(err) {
                this.handleErrors(err);
            }
        },
        seeDocument(embedCode){
            this.isSelected = true
            this.embedCode = embedCode
        }
    },
    created() {
        this.loadRiskDiagnoses();
    }
};
</script>